import { useStateWrapper } from '../../../../hooks'
import { GET_MEMBERSHIPS } from '../../../../graphql'
import { MembershipQueryType } from '../../../../types/types'
import {
  MembershipCardInfo,
  MembershipMagazinesTable,
  Memberships
} from './components'

export const Membership = () => {
  const { StateRenderWrapper, data } = useStateWrapper<MembershipQueryType>({
    query: GET_MEMBERSHIPS
  })

  return (
    <StateRenderWrapper>
      <Memberships membershipInfo={data?.membershipInfo} />
      <MembershipMagazinesTable
        membershipMagazines={data?.membershipMagazines}
      />
      <MembershipCardInfo membershipCard={data?.membershipCard} />
    </StateRenderWrapper>
  )
}
